import { AxiosPromise } from 'axios'
import { API } from '@signifyd/http'
import {
  RecommendationDisposition,
  UpdateRecommendationReviewResponse,
} from './types'

const updateRecommendationReview = (
  caseId: number,
  recommendationDisposition: RecommendationDisposition
): AxiosPromise<UpdateRecommendationReviewResponse> =>
  API.put(`/v2/cases/${caseId}/recommendation`, {
    guaranteeDisposition: recommendationDisposition,
  })

export { updateRecommendationReview }
